import styled from "styled-components";
export const StyledUsersList = styled.div`
  header.tma__user-table-filters {
    display: flex;
    gap: 0.45rem;
    margin: 1rem auto 0.5rem auto;
    align-items: center;
    .tma__input_container {
      position: relative;
      top: -2px;
    }
    button.tma_popup_btn:disabled {
      background-color: var(--input-disabled-color);
      color: grey;
    }
    .tma__input_field {
      .MuiInputBase-root {
        height: 40px;
        border-radius: 5px;
      }
    }
    button.tma__dropdown__select {
      flex-basis: 20%;
      min-width: 20%;
      height: 40px;
      border: 1px solid var(--input-border-color);
      border-radius: 5px;
    }
    a.tma__add_user_link {
      margin-left: auto;
    }
    button.tma__add_user {
      border-radius: 5px;
      padding-left: 20px;
      padding-right: 20px;
    }
    .tma_auto_complete {
      max-width: 20%;
      flex-basis: 20%;
      height: 40px;
    }
  }
  div.tma__table-container {
    height: 480px;
  }
`;
export const StyledResourceForm = styled.form`
  .resourceId{
    .MuiOutlinedInput-input.Mui-disabled{
          background-color: var(--input-disabled-color);
          color:grey;
    }
  }
  .no-box {
    box-shadow: none !important;
    border: none !important;
}
  }
  .card {
    background-color: white;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    padding: 1rem;
    border-radius: 5px;
    margin-top: 1rem;
    .tma_form_actions {
        padding: 1rem 0 0;
        .primary-outline {
        border-color: var(--primary-text);
        color: var(--primary-text);
        transition: all 0.5s ease-in-out;
        &:hover {
          background-color: var(--primary-text);
          color: white;
        }
      }
      .primary-success {
        background-color: var(--primary-text);
        transition: all 0.5s ease-in-out;
        &:hover {
          background-color: var(--primary-text-hover);
        }
      }
        button:nth-child(2) {margin: 0 1rem; }
    }

  }
  .tma_section-title {
    text-transform: uppercase;
    font-size: 15px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 0.5rem;
    &.padding-top {
        padding-top: 1rem;
    }
  }
  .tma-form_field_content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    &.two {justify-content: flex-start;}
    flex-wrap: wrap;
    gap: 0.75rem;
    padding-top: 0.75rem;
    @media (max-width: 767px) {
        gap: 0.5rem;
      }
    .tma_form-control {
      width: calc(33.33333% - 1rem);
      button {
        &.tma_app_btn.tma_file_upload_btn.newattachment {
            margin-top: 0.5rem;
            background-color: var(--primary-text);
          }
      }
      @media (max-width: 767px) {
        width: calc(50% - 0.5rem);
      }
      @media (max-width: 480px) {
        width: 100%;
      }
      label {font-size: 14px;}
      &.control-disabled {
        .MuiOutlinedInput-root {
          background-color: #f5f5f5;
        }
      }
      input {font-size: 14px !important; min-height: 23px; &.MuiInputBase-input {border-color: #ddd;}}
      .MuiFormControl-root {width: 100%;}
      input[placeholder="DD-MM-YYYY"] {padding: 8.5px 12px;}
      .tma_auto_complete fieldset,  fieldset{
        border-color: #ddd !important;
      }
      button {
        &.tma__dropdown__select {
          width: 100%;
          border-radius: 5px;
          border-color: #ddd;
          font-size: 14px;
          min-width: inherit;
        }
      }
        .fileUpload {
          display: flex;
          align-items: center;
          position: relative;
          justify-content: flex-end;
          button {
            &.tma_file_upload_btn {
              position: absolute;
              width: 100%;
              height: 100%;
              padding: 0;
              z-index: 1;
              background: transparent;
              color: var(--primary-text);
              align-items: center;
              justify-content: flex-start;
              span.tma_btn_text {
                margin-left: 0;
                background-color: var(--grid-cell-text);
                color: white;
                height: 40px;
                border-radius: 4px 0 0 4px;
                align-items: center;
                display: flex;
                padding: 0 8px;
              }
            }
          }            
            .file_download {
              color: #0766d4;
            }
            .file_download:hover {
              text-decoration: underline;
              cursor: pointer;
            }
          ul.tma_file_info_list {
            display: block;
            width: calc(100% - 107px);
            max-width: calc(100% - 107px);
            flex-basis: calc(100% - 107px);
            border: 1px solid #ddd;
            border-radius: 0 4px 4px 0;
            padding-left: 0;
            height: 40px;
            
            .file_download {
              color: #0766d4 !important;
            }
            .file_download:hover {
              text-decoration: underline;
              cursor: pointer;
            }
            li.tma_file_item {
              a {
                  text-transform: lowercase;
                  text-wrap-mode: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
              }
              .file_download {
                color: #0766d4;
              }
              .file_download:hover {
                text-decoration: underline;
                cursor: pointer;
              }
              display: flex;
              align-items: center;
              background-color: transparent;
              gap: 0.5rem;
              padding: 0.35rem;
              border-radius: 5px;
              justify-content: space-between;
              svg {display: none;}
              button.tma_file_remove {
                position: relative;
                z-index: 2;
              }
            }
          }
        }
        label {
            button {
                &.MuiButtonBase-root {padding: 0; svg {height: 18px;}}
            }
        }  
    }
    }
    .form_card {
      // border: 2px dashed #ddd;
      padding: 0rem;
      margin-top: 1rem;
      background-color: #f5f5f5;
      .tma_section-subtitle {
        color: var(--primary-text);
        font-size: 13px;
        background-color: #f5f5f5;
        padding: 0.5rem;
        border-bottom: 1px dashed #ddd;
        }
        .tma-form_field_content {
          padding: 1rem;
          &.no-padding {padding-bottom: 0;}
          input {background-color: white;}
        }
      
    }
`;

export const StyledCreateEditResourceForm = StyledResourceForm;
export const StyledUserAccountForm = styled(StyledResourceForm)`
  fieldset {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;
    .tma_input_row {
      display: flex;
      width: 100%;
      .tma__input_container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        label {
          margin-left: 0;
        }
      }
    }
  }
`;
export const StyledConfirmationContent = styled.div`
  h1 {
    font-size: 22px;
    white-space: nowrap;
    color: green;
  }
  p {
    font-size: 14px;
  }
  p.main-content {
    margin: 1rem auto;
  }
`;
export const StyledResourceLabel = styled.li`
  display: flex;
  flex-direction: column;
  align-items: baseline !important;
  gap: 0.25rem;
  p.primary {
    margin: 0;
    font-weight: bold;
  }
  p.secondary {
    color: var(--label-text);
    font-size: 0.9em;
  }
`;
export const StyledDeleteModalConfirmation = styled.div`
  .tma_delete_modal_title,
  .tma_delete_modal_content {
    padding: 0;
    margin-bottom: 1rem;
  }
`;
